import { z } from 'zod';
const getPastShiftAnalyticsParamsSchema = z.object({
    shiftId: z.string().uuid(),
    returnEmpty: z.boolean().optional(),
});
const getPastShiftAnalyticsResponseSchema = z.object({
    approvedHours: z.number(),
    pendingHours: z.number(),
    deniedHours: z.number(),
    volunteerCount: z.number(),
    positionParticipants: z.string().array(),
});
export const getPastShiftAnalyticsFunctionDef = {
    name: 'getPastShiftAnalytics',
    requestSchema: getPastShiftAnalyticsParamsSchema,
    responseSchema: getPastShiftAnalyticsResponseSchema,
};
